// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_lx-0";
export var animationContainer = "_lx-1";
export var itemPrice = "_lx-a";
export var itemizedContent = "_lx-9";
export var itemizedHeader = "_lx-7";
export var itemizedRow = "_lx-8";
export var itemizedSection = "_lx-6";
export var modalContent = "_lx-2";
export var orderName = "_lx-3";
export var refundOption = "_lx-4";
export var refundOptionsContainer = "_lx-5";
export var shippingLabel = "_lx-b";
export var totalRow = "_lx-c";